import axios from 'axios';
import { useQuery } from 'react-query';
import { adminService } from '../../../services/admin';

const API_BASE_URL = process.env.REACT_APP_API_HOST;

export function SecurityCompliancePanel() {
  const { data: security, isLoading: securityLoading } = useQuery({
    queryKey: ['security-compliance'],
    queryFn: adminService.getSecurityCompliance,
  });

  const { data: governanceResponse, isLoading: governanceLoading } = useQuery({
    queryKey: ['workspace-data-governance'],
    queryFn: async () => {
      const { data } = await axios.get(
        `${API_BASE_URL}/v1/workspace/data-governance`,
      );
      return data?.data;
    },
  });

  if (securityLoading || governanceLoading) {
    return <p className="text-sm text-gray-500">Loading compliance controls...</p>;
  }

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-gray-200 bg-white p-4">
        <h3 className="text-sm font-semibold text-gray-900">Access control</h3>
        <p className="mt-1 text-sm text-gray-600">
          Active users: {security?.accessReview?.activeUsers || 0}
        </p>
        <p className="text-sm text-gray-600">
          Privileged users: {security?.accessReview?.privilegedUsers || 0}
        </p>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-4">
        <h3 className="text-sm font-semibold text-gray-900">Data governance</h3>
        <p className="mt-1 text-sm text-gray-600">
          Data quality score: {governanceResponse?.score || 0}/100
        </p>
        {(governanceResponse?.issues || []).map((issue: any) => (
          <div key={issue.id} className="mt-2 flex items-center justify-between text-sm">
            <span className="text-gray-700">{issue.label}</span>
            <span className="text-gray-500">{issue.count}</span>
          </div>
        ))}
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-4">
        <h3 className="text-sm font-semibold text-gray-900">Control checklist</h3>
        {(security?.controls || []).map((control: any) => (
          <div key={control.id} className="mt-2 flex items-center justify-between text-sm">
            <span className="text-gray-700">{control.label}</span>
            <span
              className={`rounded-full px-2 py-0.5 text-xs ${
                control.status === 'attention'
                  ? 'bg-red-100 text-red-700'
                  : 'bg-green-100 text-green-700'
              }`}
            >
              {control.status}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
